/**
 * OCTOPUS - EngineModelsPage
 * CADASTROS › Equipamentos › Modelos de Motor.
 *
 * D-20 (Plan 14-06): "Modelos de Motor" é um CATÁLOGO de frota (`engine_models`
 * 1→N reutilizado por vários equipamentos), então ganha página própria em vez de
 * viver só dentro de um modal na aba Telemetria do equipamento. Renderiza o corpo
 * do catálogo (EngineModelsPanel) INLINE — sem modal, sem botão "Gerenciar modelos".
 * O painel já traz sua própria lista, CTA "Novo modelo" e estado vazio.
 */
import React from 'react';
import { EngineModelsPanel } from '@/components/equipments/EngineModelsManager';

const EngineModelsPage = () => {
  return (
    <div className="p-4 md:p-6 space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Modelos de Motor</h1>
        <p className="text-sm text-muted-foreground">
          Catálogo de modelos de motor da frota. Um modelo é reutilizado por vários equipamentos.
        </p>
      </div>
      <EngineModelsPanel />
    </div>
  );
};

export default EngineModelsPage;
